import axiosConfig from '../axiosConfig';

export type TFavorites = {
	id?: number;
	owner?: number;
	entity_id?: number;
	created_at?: number;
	name: string;
	entity_type: string;
	chartType?: string;
	showOnMain?: boolean;
};

export class Favorites implements TFavorites {
	id?: number;
	owner?: number;
	entity_id?: number;
	created_at?: number;
	name: string;
	entity_type: string;
	chartType?: string;
	showOnMain?: boolean;

	constructor(favorite: TFavorites) {
		this.id = favorite.id;
		this.owner = favorite.owner;
		this.entity_id = favorite.entity_id;
		this.created_at = favorite.created_at;
		this.name = favorite.name;
		this.entity_type = favorite.entity_type;
		this.chartType = favorite.chartType;
		this.showOnMain = favorite.showOnMain;
	}

	public static ToggleFavorite(favorite: TFavorites): Promise<TFavorites> {
		return axiosConfig.instance.post('app/favorite', favorite).then((res) => {
			return new Favorites(res.data as TFavorites);
		});
	}

	public static Get(object_id: number, type: string): Promise<TFavorites> {
		return axiosConfig.instance
			.get<TFavorites>(`app/favorite/${type}/${object_id}`)
			.then((res) => {
				return res.data;
			});
	}

	public static GetByType(type: string): Promise<TFavorites[]> {
		return axiosConfig.instance.get<TFavorites[]>(`app/favorite/${type}`).then((res) => {
			return res.data;
		});
	}

	public static Update(favorite: TFavorites): Promise<TFavorites> {
		return axiosConfig.instance.patch('app/favorite', favorite).then((res) => {
			return new Favorites(res.data as TFavorites);
		});
	}
}
